import { LogIn, LogOut, User as UserIcon } from 'lucide-react';
import { useAuthStore } from '../../stores/auth-store';
import { Button } from '../ui/Button';

export function AuthButton() {
  const user = useAuthStore((s) => s.user);
  const signInWithGoogle = useAuthStore((s) => s.signInWithGoogle);
  const signOut = useAuthStore((s) => s.signOut);
  const loading = useAuthStore((s) => s.loading);

  if (loading) {
    return null;
  }

  if (user) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2 px-2 py-1 rounded bg-surface">
          {user.photoURL ? (
            <img
              src={user.photoURL}
              alt={user.displayName || 'User'}
              className="w-6 h-6 rounded-full"
            />
          ) : (
            <UserIcon size={16} className="text-text-muted" />
          )}
          <span className="text-xs text-text max-w-[100px] truncate">
            {user.displayName || user.email}
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={signOut}
          title="Sign out"
        >
          <LogOut size={14} />
        </Button>
      </div>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => signInWithGoogle(true)}
      title="Sign in with Google"
    >
      <LogIn size={14} />
      <span className="ml-1.5 text-xs">Sign In</span>
    </Button>
  );
}
